import { PostHogProvider } from "posthog-js/react";
import { ApolloProviderWithAuth0 } from "./ApolloProviderWithAuth0";
import { Auth0WithNavigate } from "./Auth0WithNavigate";
import { createToastFactory, StyleRoot } from "@ttc3k/trekker";

const toastFactory = createToastFactory({
  placement: "bottom-start",
  duration: 6000,
  removeDelay: 200,
  overlap: true,
  gap: 16,
});
import "../styled-system/styles.css";
import "@fontsource-variable/figtree";
import { Outlet } from "react-router";
import { RootLayout } from "shared/components";
import { AppContextProvider } from "AppContextProvider";
import styles from "styled-system/styles.css?inline";
import swiperStyles from "swiper/css?inline";
import swiperScrollbarStyles from "swiper/css/scrollbar?inline";
import customSwiperStyles from "widgets/events/components/EventsCarousel/swiper.css?inline";
import { PostHogAppContext, usePostHog } from "shared/hooks/usePostHog";
import { AppVersion } from "shared/components/root/AppVersion";
import { TagGroupContextProvider } from "shared/contextProviders/tagGroups";
import { ImpersonationProvider } from "shared/contextProviders/impersonation";
import { FeatureFlagProvider } from "shared/contextProviders/featureFlags";
import { AdminFeatureFlagProvider } from "shared/contextProviders/adminFeatureFlags";
import { WorkbenchSessionProvider } from "shared/contextProviders/workbenchSession";
import { AppVersionProvider } from "AppVersionProvider";

export const Root = () => {
  const { posthog, initPostHog, registerPostHog } = usePostHog();

  // Initialize PostHog
  initPostHog("whereabouts-next");

  // Register the appContext property
  registerPostHog({
    appContext: PostHogAppContext.WhereaboutsNext, // This ensures all events from this instance are tagged with `appContext: "whereabouts-next"`
  });

  return (
    <AppVersionProvider>
      <Auth0WithNavigate>
        <ImpersonationProvider>
          <ApolloProviderWithAuth0>
            <PostHogProvider client={posthog}>
              <AppContextProvider>
                <WorkbenchSessionProvider>
                <FeatureFlagProvider>
                <AdminFeatureFlagProvider>
                  <TagGroupContextProvider>
                    <StyleRoot
                      styles={[
                        styles,
                        swiperStyles,
                        swiperScrollbarStyles,
                        customSwiperStyles,
                      ]}
                      toastFactoryOverride={toastFactory}
                    >
                      <RootLayout>
                        <Outlet />
                      </RootLayout>
                      {/* Last in tree so portaled overlay stacks above slideouts / other modals */}
                      <AppVersion />
                    </StyleRoot>
                  </TagGroupContextProvider>
                </AdminFeatureFlagProvider>
                </FeatureFlagProvider>
                </WorkbenchSessionProvider>
              </AppContextProvider>
            </PostHogProvider>
          </ApolloProviderWithAuth0>
        </ImpersonationProvider>
      </Auth0WithNavigate>
    </AppVersionProvider>
  );
};
